module.exports = __webpack_public_path__ + "static/img/4.4fb46ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aboutUs/4.png
// module id = jJmK
// module chunks = 1